<template>
  <div>
    <div class="footer footer-section">
      <div class="container">
        <div class="footer-list">
            <div class="footer-item">
              <div class="footer-logo">
                <img src="/static/img/c_logo.png" alt />
                <span>WORLD SHINE DATA</span>
              </div>
              <div class="footer-info">
                <img style="margin-left: 10px;" src="/static/img/footer_01.png" alt />
                <a href="http://www.usoftchina.com" target="_blank">www.usoftchina.com</a>
                <img style="margin-left: 30px;" src="/static/img/footer_02.png" alt />
                <a>400-850-8585</a>
              </div>
            </div>
			      <div class="company-logo">
              <img src="/static/img/usoft_weixin_qr2.png" alt />
              <span>华商数据公众号</span>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    problem() {
      this.$router.push({ name: "Home", params: { isporblem: false } });
      this.$store.commit("problemfalse");
      $(document).scrollTop(0);
    },
    gohome() {
      this.$store.commit("problemtrue");
    }
  }
};
</script>

<style scoped>
.footer-item{
  height: 120px;
  padding: 26px 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

}
.footer-logo{
  display: flex;
  align-items: center;
}
.footer-logo >span{
  color: #3A9BD2;
  font-size: 16.5px;
  margin-left: 30px;
}
.footer-info{
  display: flex;
  align-items: center;
}

.footer-info >a{
  color: #3A9BD2 !important;
  text-decoration: none;
  margin-left: 5px;
}
.company-logo >span{
  margin-top: 10px;
  color: #3A9BD2;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue